import { BaseHttpService, validateWithSchema } from "@/api/http/BaseHttpService";
import {
  borrowerPlatformTemplateSchema,
  type Block,
  type BorrowerPlatformTemplate,
} from "@/api/http/schemas/borrowerPlatformTemplatesSchemas";
import { fileSchema } from "./schemas/fileSchemas";
import type { ApiFile } from "./schemas/fileSchemas";

const endpoints = {
  single: "borrower_platform/borrower_platform_templates/:id",
  files: {
    single: "borrower_platform/borrower_platform_templates/:id/files/:fileId",
  },
} as const;

export class BorrowerPlatformTemplatesHttpService extends BaseHttpService {
  silentErrors = true;
  screenLoadingPaths = [endpoints.single];

  async show(id: BorrowerPlatformTemplate["id"]) {
    const url = endpoints.single.replace(":id", id);

    const { data } = await this.get<{ data: BorrowerPlatformTemplate }>(url);

    return validateWithSchema(borrowerPlatformTemplateSchema, data);
  }

  async getFile(templateId: BorrowerPlatformTemplate["id"], fileId: Block["file_id"]) {
    const url = endpoints.files.single
      .replace(":id", templateId)
      .replace(":fileId", String(fileId));

    const { data } = await this.get<{ data: ApiFile }>(url);

    return validateWithSchema(fileSchema, data);
  }
}
